

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import borders from "assets/theme-dark/base/borders";
import colors from "assets/theme-dark/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";
import linearGradient from "assets/theme-dark/functions/linearGradient";

const { borderWidth } = borders;
const { transparent, primary, outline } = colors;

const radio = {
  styleOverrides: {
    root: {
      position: "relative",
      padding: pxToRem(8),
      margin: 0,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",

      "& .MuiSvgIcon-root": {
        width: pxToRem(20),
        height: pxToRem(20),
        color: transparent.main,
        border: `${borderWidth[1]} solid ${outline.variant}`,
        borderRadius: "50%",
      },

      "&:after": {
        transition: "opacity 250ms ease-in-out",
        content: `""`,
        position: "absolute",
        width: pxToRem(10),
        height: pxToRem(10),
        borderRadius: "50%",
        backgroundImage: linearGradient(primary.main, primary.main),
        opacity: 0,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: "auto",
      },

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-focusVisible": {
        border: `${borderWidth[2]} solid ${primary.main} !important`,
      },
    },

    colorPrimary: {
      color: outline.variant,

      "&.Mui-checked": {
        color: primary.main,

        "& .MuiSvgIcon-root": {
          borderColor: primary.main,
        },

        "&:after": {
          opacity: 1,
        },
      },
    },

    colorSecondary: {
      color: outline.variant,

      "&.Mui-checked": {
        color: primary.main,

        "& .MuiSvgIcon-root": {
          borderColor: primary.main,
        },

        "&:after": {
          opacity: 1,
        },
      },
    },
  },
};

export default radio;
